import { AlertDialog, AlertDialogContent } from '@/components/ui/alert-dialog';
import { useAtomValue } from 'jotai';
import {
  currentjobChangeProcessStatusAtom,
  currentSelectjobChangeProcessAtom,
} from '../../atoms/jobChangeProcess';
import StatusNextStepModalContents from './StatusNextStepModalContents';
import StatusOfferModalContents from './StatusOfferModalContents';
import StatusDeclineModalContents from './StatusDeclineModalContents';
import StatusCloseModalContents from './StatusCloseModalContents';
import StatusRejectModalContents from './StatusRejectModalContents';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  jobchangeProcessesRefetch: () => Promise<void>;
};
export default function JobChangeProcessStatusUpdateModal({
  open,
  onOpenChange,
  jobchangeProcessesRefetch,
}: Props) {
  const currentSelectjobChangeProcess = useAtomValue(currentSelectjobChangeProcessAtom);
  const currentjobChangeProcessStatus = useAtomValue(currentjobChangeProcessStatusAtom);

  const close = () => onOpenChange(false);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-h-[90vh] max-w-max overflow-auto">
        {currentjobChangeProcessStatus === 'progress' && currentSelectjobChangeProcess && (
          <StatusNextStepModalContents
            jobChangeProcess={currentSelectjobChangeProcess}
            close={close}
            jobchangeProcessesRefetch={jobchangeProcessesRefetch}
          />
        )}
        {currentjobChangeProcessStatus === 'offer' && currentSelectjobChangeProcess && (
          <StatusOfferModalContents
            jobChangeProcessId={currentSelectjobChangeProcess.id}
            close={close}
            jobchangeProcessesRefetch={jobchangeProcessesRefetch}
          />
        )}
        {currentjobChangeProcessStatus === 'close' && currentSelectjobChangeProcess && (
          <StatusCloseModalContents
            jobChangeProcessId={currentSelectjobChangeProcess.id}
            close={close}
            jobchangeProcessesRefetch={jobchangeProcessesRefetch}
          />
        )}
        {currentjobChangeProcessStatus === 'decline' && currentSelectjobChangeProcess && (
          <StatusDeclineModalContents
            jobChangeProcess={currentSelectjobChangeProcess}
            close={close}
            jobchangeProcessesRefetch={jobchangeProcessesRefetch}
          />
        )}
        {currentjobChangeProcessStatus === 'reject' && currentSelectjobChangeProcess && (
          <StatusRejectModalContents
            jobChangeProcess={currentSelectjobChangeProcess}
            close={close}
            jobchangeProcessesRefetch={jobchangeProcessesRefetch}
          />
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
}
